import API from './config'

export const SuitabilitiesAPI = {



    async getActiveSuitabilitieQuestionary() {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/suitabilities/getActiveSuitabilitieQuestionary`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getSuitabilitiesByClientId(clientId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/suitabilities/getSuitabilitiesByClientId?client_id=${clientId}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async saveSuitability(obj) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/suitabilities/saveSuitability`, obj, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("Error: ", error);

            return {
                success: false,
                body: error.response.data
            };
        }
    },



}